export default __webpack_public_path__ + "static/media/useLogo.de2a028f.svg";